import React from 'react'
import { AddressElement } from '@stripe/react-stripe-js'

import InputField from './InputField'

const Contact = ({ i18n, donation, errors, resetError, collect_phone, session }) => {
  const { state, dispatch } = donation

  const inputPropsFor = id => ({
    value: state[id],
    onChange: e => {
      dispatch({ type: 'setFieldValue', field: id, value: e.target.value })
      resetError?.(id)
    },
  })

  return (
    <div className="space-y-3">
      {!donation.collectAddress && (
        <div className="grid grid-cols-1 gap-x-2 gap-y-3 @roomy:grid-cols-2">
          <InputField
            id="firstName"
            label={i18n.t('first_name')}
            required
            error={errors.firstName}
            {...inputPropsFor('firstName')}
          />
          <InputField
            id="lastName"
            label={i18n.t('last_name')}
            required
            error={errors.lastName}
            {...inputPropsFor('lastName')}
          />
        </div>
      )}

      {session.collect_email && (
        <InputField
          id="email"
          type="email"
          label={i18n.t('email')}
          required
          error={errors.email}
          data-plg-donor-field="email"
          {...inputPropsFor('email')}
        />
      )}

      {collect_phone && !donation.collectAddress && (
        <InputField
          id="phone"
          type="tel"
          label={i18n.t('phone')}
          required
          error={errors.phone}
          {...inputPropsFor('phone')}
        />
      )}

      {donation.collectAddress && (
        // Lives in the outer StripeWrapper Elements scope (no mode/amount
        // needed for AddressElement). Onchange writes back into donation
        // state so StripePayment.confirmPayment can read billing details
        // when the donor reaches the Stripe step. AddressElement renders
        // its own first/last name fields under display.name='split' and
        // surfaces phone inline when collect_phone is on, so the standalone
        // first/last/phone inputs are skipped to avoid duplication.
        <AddressElement
          options={{
            mode: 'billing',
            display: { name: 'split' },
            defaultValues: {
              firstName: state.firstName,
              lastName: state.lastName,
              address: state.address || {},
              ...(collect_phone && state.phone ? { phone: state.phone } : {}),
            },
            ...(collect_phone ? {
              fields: { phone: 'always' },
              validation: { phone: { required: 'always' } },
            } : {}),
          }}
          onChange={({ value }) =>
            dispatch({ type: 'setAddress', value })
          }
        />
      )}
    </div>
  )
}

export default Contact
